/** @jsxImportSource theme-ui */
import { gql } from "@apollo/client";
import { Flex } from "@bottlebooks/gatsby-design-system";
import { graphql } from "~/gql";
import ProductInfoSheetButton from "./ProductActions/ProductInfoSheetButton";
import ProductShopButton from "./ProductActions/ProductShopButton";

export default function ProductActions({ product }) {
  return (
    <Flex
      direction={["column", "row"]}
      sx={{ gap: 2, alignItems: ["stretch", "center"] }}
    >
      <ProductShopButton product={product} />
      <ProductInfoSheetButton product={product} />
    </Flex>
  );
}

// export const fragment = graphql(`
//   fragment bb_ProductActions on Bottlebooks_Product {
//     ...bb_ProductShopButton
//   }
//   fragment bb_ProductActions_RegisteredProduct on Bottlebooks_RegisteredProduct {
//     ...bb_ProductInfoSheetButton
//   }
// `);

// ProductActions.fragment = gql`
//   fragment ProductActions on Product {
//     ...ProductShopButton
//   }
//   fragment ProductActions_RegisteredProduct on RegisteredProduct {
//     ...ProductInfoSheetButton
//   }
//   ${ProductShopButton.fragment}
//   ${ProductInfoSheetButton.fragment}
// `;
